import { ImageStatus } from '@/api/types';

/**
 * Human-readable label for a numeric ImageStatus ordinal. Mirrors the
 * upload -> validation -> metadata extraction -> thumbnail generation ->
 * watermark generation -> storage pipeline in
 * backend/src/Aperture.Domain/Media/ImageStatus.cs, run asynchronously by
 * Aperture.Workers off the jobs:image-processing queue.
 */
export const IMAGE_STATUS_LABELS: Record<ImageStatus, string> = {
  [ImageStatus.Uploaded]: 'Naloženo - v čakalni vrsti za obdelavo',
  [ImageStatus.Validating]: 'Preverjanje',
  [ImageStatus.ValidationFailed]: 'Preverjanje neuspešno',
  [ImageStatus.MetadataExtracted]: 'Branje metapodatkov',
  [ImageStatus.ThumbnailGenerated]: 'Ustvarjanje sličice',
  [ImageStatus.WatermarkGenerated]: 'Ustvarjanje vodnega žiga',
  [ImageStatus.Stored]: 'Obdelano',
  [ImageStatus.Failed]: 'Obdelava neuspešna',
};

export function imageStatusLabel(status: ImageStatus): string {
  return IMAGE_STATUS_LABELS[status] ?? `Neznano (${status})`;
}

/** True once the async processing pipeline has finished (successfully or not). */
export function isImageProcessingDone(status: ImageStatus): boolean {
  return status === ImageStatus.Stored || status === ImageStatus.Failed || status === ImageStatus.ValidationFailed;
}
